module.exports = __webpack_public_path__ + "img/Bio.d933c508.jpg";